import script from "./Chance.vue?vue&type=script&setup=true&lang=js"
export * from "./Chance.vue?vue&type=script&setup=true&lang=js"

import "./Chance.vue?vue&type=style&index=0&id=3d4db28b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4db28b"]])

export default __exports__